import { ReactNode } from 'react'
import { CalendarIcon } from '../../../../assets/icons/CalendarIcon'
import { EnvironmentIcon } from '../../../../assets/icons/EnvironmentIcon'
import { BankIcon } from '../../../../assets/icons/BankIcon'
import { UserIcon } from '../../../../assets/icons/UserIcon'
import { JurisdictionsCircleIcon } from '../../../../assets/icons/JurisdictionsCircleIcon'
import { CompanyOverviewEntityForTable } from 'containers/CompanyOverviewTablePage/types'

type RenderFn<T = unknown> = (value: T, fullEntity?: CompanyOverviewEntityForTable) => ReactNode

export const overviewMapping: {
  key: string
  label: string
  tooltipText?: string
  icon?: ReactNode
  render?: RenderFn
}[] = [
  { key: 'founded', label: '', icon: <CalendarIcon size={14} /> },
  { key: 'location', label: '', icon: <EnvironmentIcon size={14} /> },
  { key: 'entityType', label: 'Company Type', icon: <BankIcon size={14} /> },
  {
    key: 'totalEmployees',
    label: 'Employees',
    icon: <UserIcon size={14} />,
    render: (_value, fullEntity) => fullEntity?.totals?.totalEmployees ?? 'N/A',
  },
  { key: 'jurisdictions', label: 'Jurisdictions', icon: <JurisdictionsCircleIcon size={14} /> },
]
